module.exports = __webpack_public_path__ + "img/Barbs 150px.62772a5b.png";